import { render, staticRenderFns } from "./Dob.vue?vue&type=template&id=12780363"
import script from "./Dob.vue?vue&type=script&lang=js"
export * from "./Dob.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports